<template>
  <div class="the-sticky-footer-button">
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
.the-sticky-footer-button {
  position: sticky;
  bottom: 0;
  background: $common-white;
  border-top: px(1) solid $customize-light-gray;
  padding: rem(8) rem(20) rem(10) rem(20);
  display: flex;
  justify-content: center;
  z-index: 10;
}
</style>
